/*
 *
 * TreatmentFlow reducer
 *
 */

import { fromJS } from "immutable";
import {
  GET_CONFIGURATION,
  GET_PRODUCT_TYPES,
  GET_PRODUCT_TYPES_ERROR,
  GET_PRODUCT_TYPES_SUCCESS,
  GET_ACTIVE_PRODUCT_PLAN,
  GET_ACTIVE_PRODUCT_PLAN_SUCCESS,
  GET_ACTIVE_PRODUCT_PLAN_ERROR,
  CREATE_ACTION_PLAN,
  CREATE_ACTION_PLAN_SUCCESS,
  CREATE_ACTION_PLAN_ERROR,
  GET_PRODUCT_CONFIGURATION,
  GET_PRODUCT_CONFIGURATION_SUCCESS,
  GET_PRODUCT_CONFIGURATION_ERROR,
  RESET,
} from "./constants";

export const initialState = fromJS({
  types: [],
  currentConfiguration: {},
  initialLoading: false,
  loading: false,
  error: "",
});

function treatmentFlowReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_ACTION_PLAN_SUCCESS:
      return state.set("loading", false).set("productPlan", action.data);

    case GET_ACTIVE_PRODUCT_PLAN_SUCCESS:
      return state.set("loading", false).set("productPlan", action.data);

    case GET_ACTIVE_PRODUCT_PLAN:
    case CREATE_ACTION_PLAN:
      return state.set("loading", true).set("error", "");

    case GET_PRODUCT_TYPES:
      return state.set("initialLoading", true).set("error", "");

    case GET_PRODUCT_TYPES_SUCCESS:
      return state.set("initialLoading", false).set("types", action.data);

    case GET_PRODUCT_TYPES_ERROR:
      return state.set("initialLoading", false).set("error", action.error);

    case GET_ACTIVE_PRODUCT_PLAN_ERROR:
    case CREATE_ACTION_PLAN_ERROR:
      return state.set("loading", false).set("productPlan", {});

    case GET_CONFIGURATION:
      return state.set(
        "currentConfiguration",
        state
          .get("configurations")
          .find(
            ({ lowerProductTypeId, upperProductTypeId }) =>
              lowerProductTypeId === action.lowerId &&
              upperProductTypeId === action.upperId,
          ),
      );

    case GET_PRODUCT_CONFIGURATION_SUCCESS:
      return state.set("currentConfiguration", action.data);

    case RESET:
      return initialState;

    default:
      return state;
  }
}

export default treatmentFlowReducer;
